import { Persistent320x50AdForMobileWeb } from '../common/interfaces/types';

export const getPageCfgToRenderPersistent320x50Ad = (configs: Persistent320x50AdForMobileWeb, pageId: string) => {
    if (!configs?.ConfiguredPagesWithPersistent320x50Ads?.length || !pageId) {
        return;
    }

    const pageCfg = configs.ConfiguredPagesWithPersistent320x50Ads.find(cfg => cfg.PageId === pageId);

    return pageCfg;
};